module.exports = __webpack_public_path__ + "static/media/menu.b520d9c4.svg";